<template>
    <div class="map-privacy rounded mt-1 px-1 small" v-if="project.locationPrivacy"
        :title="`Locations are blurred to ${locationPrivacySqKm} sq km (${locationPrivacySqMi} sq mi). Managers see exact coordinates, while everyone else sees blurred locations.`"
        v-b-tooltip.hover>
        <i class="fa fa-info-circle"></i>
        <span v-if="isManager">Managers see exact coordinates.</span>
        <span v-else>Locations are blurred</span>
    </div>
</template>
<script>
export default {
    name: "LocationPrivacyTooltip",
    props: {
        project: {
            type: Object,
            required: true
        },
        isManager: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        locationPrivacySqKm() {
            if (!this.project || this.project.locationPrivacy === undefined || this.project.locationPrivacy === null) {
                return undefined
            }
            //return this.newProject.locationPrivacy
            const earthSizeSQKM = 510072000.0; // Earth's surface area in square kilometers
            const privacyLevel = this.project.locationPrivacy;
            const privacyAreaSQKM = earthSizeSQKM / (Math.pow(privacyLevel, 2) * 12);
            // round down to nearest 1 decimal place
            return Math.floor(privacyAreaSQKM * 10) / 10;
        },
        locationPrivacySqMi() {
            if (!this.locationPrivacySqKm) {
                return undefined
            }
            const privacyAreaSQMI = this.locationPrivacySqKm * 0.386102; // convert sq km to sq mi
            // round down to nearest 1 decimal place
            return Math.floor(privacyAreaSQMI * 10) / 10;
        }
    }
}
</script>
<style lang="css" scoped>
.map-privacy {
    background-color: rgba(255, 255, 255, 0.8);
    width: fit-content;
}
</style>